export default __webpack_public_path__ + "static/media/star_empty.b9d1a950.svg";